import { FC, SVGProps } from 'react'

// Line icons from the Ad Performance design (24px, 1.5 stroke, currentColor).
type P = SVGProps<SVGSVGElement>
const Svg: FC<P> = ({ children, ...p }) => (
  <svg
    fill="none"
    height={24}
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={1.5}
    viewBox="0 0 24 24"
    width={24}
    {...p}
  >
    {children}
  </svg>
)

export const SpendIcon: FC<P> = (p) => (
  <Svg {...p}>
    <rect height="13" rx="2.5" width="20" x="2" y="5.5" />
    <rect height="8" rx="1.5" width="15" x="4.5" y="8" />
    <circle cx="12" cy="12" r="2" />
  </Svg>
)
export const ClickIcon: FC<P> = (p) => (
  <Svg {...p}>
    <path d="M4.5 4.5 19 10.2l-6.2 2.6-2.6 6.2L4.5 4.5Z" />
  </Svg>
)
export const EyeIcon: FC<P> = (p) => (
  <Svg {...p}>
    <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z" />
    <circle cx="12" cy="12" r="3" />
  </Svg>
)
export const CtrIcon: FC<P> = (p) => (
  <Svg {...p}>
    <rect height="17" rx="4" width="17" x="3.5" y="3.5" />
    <rect height="5" rx="1.5" width="3" x="7.5" y="11" />
    <rect height="8" rx="1.5" width="3" x="13.5" y="8" />
  </Svg>
)
export const EngageIcon: FC<P> = (p) => (
  <Svg {...p}>
    <path d="M12 4c4.7 0 8.5 3.1 8.5 7s-3.8 7-8.5 7c-1 0-2-.1-2.9-.4L5 20l.9-3.7C4.4 15 3.5 13.1 3.5 11c0-3.9 3.8-7 8.5-7Z" />
  </Svg>
)
export const UsersIcon: FC<P> = (p) => (
  <Svg {...p}>
    <circle cx="7" cy="7" r="2.5" />
    <circle cx="17" cy="7" r="2.5" />
    <circle cx="12" cy="14" r="2.5" />
    <path d="M3 13.5c.6-1.5 2-2.5 4-2.5M21 13.5c-.6-1.5-2-2.5-4-2.5M7.5 21c.5-2 2.3-3.5 4.5-3.5s4 1.5 4.5 3.5" />
  </Svg>
)
export const GenderIcon: FC<P> = (p) => (
  <Svg {...p}>
    <circle cx="10" cy="14" r="6" />
    <path d="M14.5 9.5 20 4M15 4h5v5" />
  </Svg>
)
export const CoinIcon: FC<P> = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="9" />
    <circle cx="12" cy="12" r="6.5" />
    <path d="M13.8 9.8c-.3-.6-1-1-1.8-1-1.1 0-1.9.6-1.9 1.4 0 1.9 3.8 1 3.8 3 0 .8-.9 1.5-1.9 1.5-.8 0-1.6-.4-1.9-1.1M12 7.8v1M12 15.2v1" />
  </Svg>
)
export const GridIcon: FC<P> = (p) => (
  <Svg {...p}>
    <rect height="7" rx="2" width="7" x="3.5" y="3.5" />
    <rect height="7" rx="2" width="7" x="3.5" y="13.5" />
    <rect height="7" rx="2" width="7" x="13.5" y="13.5" />
    <rect height="7" rx="2" width="7" x="13.5" y="3.5" />
  </Svg>
)
export const ChartBoxIcon: FC<P> = (p) => (
  <Svg {...p}>
    <rect height="17" rx="4" width="17" x="3.5" y="3.5" />
    <path d="m7.5 15 3-3.5 2.5 2 3.5-4.5M14.5 9h2v2" />
  </Svg>
)
export const BoltIcon: FC<P> = (p) => (
  <Svg {...p}>
    <path d="M13.5 3 5.5 13.5h6l-1 7.5 8-10.5h-6l1-7.5Z" />
  </Svg>
)
export const WarnIcon: FC<P> = (p) => (
  <Svg {...p}>
    <path d="M10.3 4.4 2.9 17.5A2 2 0 0 0 4.6 20.5h14.8a2 2 0 0 0 1.7-3L13.7 4.4a2 2 0 0 0-3.4 0Z" />
    <path d="M12 9.5v4M12 16.8v.2" />
  </Svg>
)
export const GearIcon: FC<P> = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="3" />
    <path d="M12 2.8 14 4.9l2.9-.3.6 2.9 2.5 1.4-1.1 2.7 1.1 2.7-2.5 1.4-.6 2.9-2.9-.3L12 21.2l-2-2.1-2.9.3-.6-2.9-2.5-1.4 1.1-2.7L4 9.6l2.5-1.4.6-2.9 2.9.3L12 2.8Z" />
  </Svg>
)
export const ChevronDown: FC<P> = (p) => (
  <Svg {...p}>
    <path d="m6 9 6 6 6-6" />
  </Svg>
)
export const ChevronLeft: FC<P> = (p) => (
  <Svg {...p}>
    <path d="m15 6-6 6 6 6" />
  </Svg>
)
export const ChevronRight: FC<P> = (p) => (
  <Svg {...p}>
    <path d="m9 6 6 6-6 6" />
  </Svg>
)
export const PlusCircle: FC<P> = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 8.5v7M8.5 12h7" />
  </Svg>
)
export const SearchIcon: FC<P> = (p) => (
  <Svg {...p}>
    <circle cx="11" cy="11" r="6.5" />
    <path d="m16 16 4 4" />
  </Svg>
)
export const CheckIcon: FC<P> = (p) => (
  <Svg {...p}>
    <path d="m5 12.5 4.5 4.5L19 7.5" />
  </Svg>
)
export const BulbIcon: FC<P> = (p) => (
  <Svg {...p}>
    <path d="M9 18h6M10 21h4M12 3a6 6 0 0 0-3.5 10.9c.6.4 1 1.1 1 1.9V16h5v-.2c0-.8.4-1.5 1-1.9A6 6 0 0 0 12 3Z" />
  </Svg>
)
export const PlayIcon: FC<P> = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="m10 8.5 5 3.5-5 3.5v-7Z" fill="currentColor" />
  </Svg>
)
export const ImageIcon: FC<P> = (p) => (
  <Svg {...p}>
    <rect height="16" rx="3" width="18" x="3" y="4" />
    <circle cx="9" cy="9.5" r="1.5" />
    <path d="m4 17 5-4.5 4 3.5 3-2.5 4 3.5" />
  </Svg>
)
export const CarouselIcon: FC<P> = (p) => (
  <Svg {...p}>
    <rect height="14" rx="2" width="10" x="7" y="5" />
    <path d="M4 7v10M20 7v10" />
  </Svg>
)
export const LinkIcon: FC<P> = (p) => (
  <Svg {...p}>
    <path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1" />
    <path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1" />
  </Svg>
)
